import React from "react";

const PageLoader = ({ isFullScreen = false }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: isFullScreen ? "100vh" : "60vh",
        width: "100%",
        position: isFullScreen ? "fixed" : "relative",
        top: 0,
        left: 0,
        zIndex: 9999,
        backgroundColor: isFullScreen ? "rgba(255, 255, 255, 0.8)" : "transparent",
        backdropFilter: isFullScreen ? "blur(5px)" : "none",
        transition: "all 0.3s ease",
      }}
    >
      <div className="spinner-chase">
        <div className="chase-dot"></div>
        <div className="chase-dot"></div>
        <div className="chase-dot"></div>
        <div className="chase-dot"></div>
        <div className="chase-dot"></div>
        <div className="chase-dot"></div>
      </div>
    </div>
  );
};

export default PageLoader;
